import { createActorContext } from "@xstate/react";
import { createTagEditorMachine } from "./tagEditorMachine";

export const TagEditorContext = createActorContext(createTagEditorMachine);

export const TagMachineProvider = TagEditorContext.Provider;
export const useTagMachine = TagEditorContext.useActorRef;
export const useTagMachineSelector = TagEditorContext.useSelector;
